import { render } from "./SupplierLedger.vue?vue&type=template&id=196f8e04&scoped=true"
import script from "./SupplierLedger.vue?vue&type=script&lang=js"
export * from "./SupplierLedger.vue?vue&type=script&lang=js"

import "./SupplierLedger.vue?vue&type=style&index=0&id=196f8e04&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196f8e04"]])

export default __exports__